import { Component, input, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  ButtonComponent,
  ButtonLoadingDirective,
  GroupComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-panel-footer',
  templateUrl: './evaluation-panel-footer.component.html',
  styleUrls: ['./evaluation-panel-footer.component.less'],
  imports: [TranslatePipe, GroupComponent, ButtonComponent, ButtonLoadingDirective],
})
export class EvaluationPanelFooterComponent {
  protected readonly hasAutoSaveInfo = input<boolean>(false);
  protected readonly isSubmitDisabled = input<boolean>(false);
  protected readonly isLoading = input<boolean>(false);
  protected readonly submitLabelKey = input<string>('app.evaluation_panel.add_evaluation');

  public readonly cancel = output<void>();
  public readonly clearForm = output<void>();
  public readonly submit = output<void>();
}
